import {Component, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatSnackBar} from '@angular/material';
import {Observable} from 'rxjs/Observable';

import {FuseTranslationLoaderService} from '../../../core/services/translation-loader.service';
import {ErrorResponse} from '../../../data/model/errorResponse';
import {Organisation} from '../../../data/model/organisation';
import {User} from '../../../data/model/user';
import {OrganisationsDataManager} from '../../../data/organisations.datamanager';
import {UsersDataManager} from '../../../data/users.datamanager';
import {ConfirmDialogComponent} from '../dialogs/confirm/confirm.dialog.component';

import {AddOrganisationDialogComponent} from './add/add.organisation.dialog.component';
import {AddAdminDialogComponent} from './admin/add.admin.dialog.component';
import {EditOrganisationDialogComponent} from './edit/edit.organisation.dialog.component';
import {locale as english} from './i18n/en';
import {locale as turkish} from './i18n/tr';

@Component({
  selector: 'fuse-organisations',
  templateUrl: './organisations.component.html',
  styleUrls: ['./organisations.component.scss']
})
export class FuseOrganisationsComponent implements OnInit {
  message: string;

  rows: Organisation[];
  organisationList: Organisation[];
  userlist: User[];

  constructor(
      private dialog: MatDialog, public snackBar: MatSnackBar,
      private translationLoader: FuseTranslationLoaderService,
      private organisationsDataManager: OrganisationsDataManager,
      private usersDataManager: UsersDataManager) {
    this.translationLoader.loadTranslations(english, turkish);
  }

  removeOrganisationButtonClick(id) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      height: '170px',
      width: '300px',
      data: {dialogTitle: 'Delete Organisation?', accept: 'true'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== null && result !== undefined) {
        if (result === 'true') {
          this.organisationsDataManager.deleteOrganisation(id).subscribe(
              (response) => {
                this.showMessage('Organisation deleted');
                this.ngOnInit();
              },
              (err) => {
                this.showError(err.json());
              });
        }
      }
    });
  }

  addOrganisationButtonClick() {
    const dialogRef = this.dialog.open(
        AddOrganisationDialogComponent,
        {height: '720px', width: '600px', data: {}});

    dialogRef.afterClosed().subscribe(result => {
      if (result !== null && result !== undefined) {
        if (typeof result === 'string') {
          this.showMessage(result);
          this.ngOnInit();
        } else {
          this.showError(result);
        }
      }
    });
  }

  editOrganisationButtonClick(organisationId: string, rowIndex: number) {
    const organisation = this.rows[rowIndex];

    const dialogRef = this.dialog.open(EditOrganisationDialogComponent, {
      height: '800px',
      width: '600px',
      data: {
        organisation: organisation
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== null && result !== undefined) {
        if (typeof result === 'string') {
          this.showMessage(result);
          this.ngOnInit();
        } else {
          this.showError(result);
        }
      }
    });
  }


  addAdminButtonClick(organisationId) {
    const dialogRef = this.dialog.open(
        AddAdminDialogComponent, {height: '370px', width: '600px', data: {}});

    dialogRef.afterClosed().subscribe(result => {
      if (result !== null && result !== undefined) {
        if (result.adminName !== null && result.adminName !== undefined) {
          this.usersDataManager
              .createAdmin(
                  result.adminName, result.adminEmail, 'admin', organisationId)
              .subscribe(
                  (res) => {
                    this.showMessage('Admin: ' + res.name + ' created.');
                    this.ngOnInit();
                  },
                  (err) => {
                    this.showError(err.json());
                  });
        }
      }
    });
  }

  setUsers() {
    if (this.organisationList !== null || this.organisationList !== undefined) {
      this.organisationList.forEach((organisation, orgIndex, orgArray) => {
        this.usersDataManager.getUsersByOrganisationId(organisation._id)
            .subscribe(
                (response) => {
                  organisation.adminlist = [];
                  organisation.userlist = response;
                  response.forEach((user, index, array) => {
                    if (user.role === 'admin' || user.role === 'instructor' ||
                        user.role === 'superadmin') {
                      organisation.adminlist.push(user);
                    }
                  });
                  if (orgIndex === (orgArray.length - 1)) {
                    this.rows = this.organisationList;
                  }
                },
                (err) => {
                  this.rows = this.organisationList;
                });
      });
    }
  }

  showMessage(message: string) {
    this.snackBar.open(message, null, {duration: 5000});
  }

  showError(message: ErrorResponse) {
    if (message.errors !== null && message.errors !== undefined &&
        message.errors.length > 0) {
      this.snackBar.open(message.errors[0].message, null, {duration: 10000});
    } else {
      this.snackBar.open('Unknown error occured', null, {duration: 10000});
    }
  }

  ngOnInit() {
    this.organisationsDataManager.getAllOrganisations().subscribe(
        (res) => {
          if (res.length > 0) {
            this.organisationList = res;
            this.setUsers();
          }
        },
        (err) => {
          this.showError(err.json());
        });
  }
}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/organisations/organisations.component.ts